// extracted by mini-css-extract-plugin
export var closeButton = "_27-3";
export var header = "_27-0";
export var link = "_27-1";
export var retryButton = "_27-2";